module.exports = __webpack_public_path__ + "img/新闻.1896b4e2.svg";